<template>
	<div>
		<el-form :label-width="labelWidth">
			<el-form-item
			 style="maring-bottom:10px;"
			 :label="label"
			 v-if="newLine"
			>
			<span style="font-size:12px">{{titleName}}</span>
			</el-form-item>
			<el-form-item  v-if="newLine"
				 style="maring-bottom:10px;font-weight:blod;"
				 label=" "
				 :required="required">
				<div style="border:1px solid #cccccc;min-height:35px;line-height:35px;width:90%;padding-left:10px">
					<el-tag
						v-for="tag in dynamicTags"
						:key="tag.name"
						closable
						effect="dark"
						type="info"
						@close="handleClose(tag)">
						{{tag.name}}
					</el-tag>
				</div>
			</el-form-item>
			<el-form-item v-else
				 style="maring-bottom:10px;font-weight:blod;"
			 	:label="label"
				:required="required">
				<div style="border:1px solid #cccccc;min-height:35px;line-height:35px;width:90%;padding-left:10px">
					<el-tag
						v-for="tag in dynamicTags"
						:key="tag.name"
						closable
						effect="dark"
						type="info"
						@close="handleClose(tag)">
						{{tag.name}}
					</el-tag>
				</div>
			</el-form-item>
			<el-form-item style="maring-bottom:10px">
				<el-tag
					v-for="tag in tags"
					:key="tag.name"
					effect="dark"
					type="info"
					@click="handlePickTag(tag)">
					{{tag.name}}
				</el-tag>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
  props: {
		label: String,
		labelWidth: {
			type: String,
			default: "60px"
		},
		newLine:{
			type: Boolean,
			default: false
		},
		titleName: String,
		dynamicTags: {
			type: Array,
			default: function() {
				return [];
			}
		},
		tags: {
			type: Array,
			default: function() {
				return [];
			}
		},
		required: {
			type: Boolean,
			default: true
		}
	},
	created() {
		this.init();
	},
	updated: function () {
  this.$nextTick(function () {
    this.init();
  })
},
	methods:{
		init() {
			if(this.dynamicTags.length > 0) {
				this.dynamicTags.map(v=>{
					this.tags.map((item,i)=>{
						if(v.itemDictCode) {
							if(item.name == v.name) {
								this.tags.splice(i, 1);
							}
						} else {
							if(item.id == v.id) {
								this.tags.splice(i, 1);
							}
						}
					})
				})
			}
		},
		sortNumber(a,b){
			return a.index - b.index
		},
		handleClose(tag) {
			this.$emit('handleTagClose',tag);
			this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			this.tags.push(tag);
			this.tags.sort(this.sortNumber)
		},
		handlePickTag(tag) {
			this.$emit('handleTagPick',tag);
			this.dynamicTags.push(tag);
			this.tags.splice(this.tags.indexOf(tag), 1);
		}
	}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PickTags/index.vue